import textStyles from '../assets/styles/text.module.scss'

export const asRem = (value: number) => `${Number(value / 12).toFixed(3)}rem`

export { textStyles }
